/* tslint:disable */
/* eslint-disable */
export enum WorkStatusSelectorEnum {
  Contacts = 'Contacts',
  Projects = 'Projects',
  Absences = 'Absences',
  Documents = 'Documents',
  Equipmentlogs = 'equipmentlogs',
  Tickets = 'tickets'
}
